import axios from "axios";
import { getHostname } from "./server/server";

const hostname = getHostname();
const path = '/v2/playlist';

const getPlaylists = async (customerId, musicPlayerId) => {
    const res = await axios.get(`${hostname}${path}/playlists?customerId=${customerId}&musicPlayerId=${musicPlayerId}`);
    return res.data;
}

const updatePlaylist = async (playlistProps) => {
    const res = await axios.put(`${hostname}${path}`, playlistProps);
    return res.data;
}

const addPlaylist = async (playlistProps) => {
    const res = await axios.post(`${hostname}${path}`, playlistProps);
    return res.data;
}

const deletePlaylist = async (playlistId) => {
    const res = await axios.delete(`${hostname}${path}?playlistId=${playlistId}`);
}


export {
    getPlaylists,
    updatePlaylist,
    addPlaylist,
    deletePlaylist
}